import React, { useMemo } from "react";
import { isNumber } from "lodash";

import ExecutorReport from "../../../../../../../../../../services/ExecutorReport";
import Language from "../../../../../../../../../../services/Language";
import formatNumber from "../../../../../../../../../../utils/formatNumber";
import { CellContentRoot } from "../../../../../../../../../../components/LightTable";

export const cellProcessing = (item: OverallCashCellContent.Props["item"]) => {
	if (!isNumber(item?.executorRate?.cashDesk)) return "";
	return formatNumber(item?.executorRate?.cashDesk);
};

const OverallCashCellContent: React.FC<OverallCashCellContent.Props> = ({
	item,
}) => {
	const content = useMemo(() => cellProcessing(item), [item]);

	return (
		<CellContentRoot alignItems="center" w="100%" h="100%">
			{content}
		</CellContentRoot>
	);
};

declare namespace OverallCashCellContent {
	interface Props {
		item: ExecutorReport.Model;
		language: Language;
	}
}

export default OverallCashCellContent;
